export const SearchIcon = ({ color = "#f97316", onClick }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={28}
    height={28}
    onClick={onClick}
    viewBox="0 0 64 64"
  >
    {/* Círculo da lupa */}
    <circle
      cx="28"
      cy="28"
      r="14"
      fill="white"
      stroke={color}
      strokeWidth="5"
    />

    {/* Cabo da lupa (mais grosso) */}
    <line
      x1="39"
      y1="39"
      x2="50"
      y2="50"
      stroke={color}
      strokeWidth="7"   // aumentei de 3 para 5
      strokeLinecap="round"
    />
  </svg>
);